// extracted by mini-css-extract-plugin
export default {"planConnector":"ConfirmStep_planConnector__HISqJ","planConnectorIcon":"ConfirmStep_planConnectorIcon__1LZJg"};